import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchJourney } from "../../services/studioService";

// Parcours produit piloté par le serveur (Cinema Studio / Ads / A-B / Shopify).
// Rendu identique pour tous : progression, étapes, CTA vers l'écran concerné.
const JourneyFlow = ({ source = null, title = null, onDone = null }) => {
  const navigate = useNavigate();
  const [journey, setJourney] = useState(null);
  const [step, setStep] = useState(0);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchJourney(source ? { source } : {})
      .then(setJourney)
      .catch(() => setError(true));
  }, [source]);

  if (error) return <p className="text-sm text-gray-400 p-4">Parcours indisponible.</p>;
  if (!journey) return <div className="flex justify-center py-16"><div className="w-7 h-7 border-4 border-[#221C51]/20 border-t-[#221C51] rounded-full animate-spin" /></div>;

  const steps = journey.steps || [];
  const cur = steps[step];
  const last = step === steps.length - 1;
  const go = () => { if (cur?.cta?.route) navigate(cur.cta.route); onDone && onDone(); };

  return (
    <div className="max-w-3xl">
      <div className="mb-5">
        <h2 className="text-2xl font-bold text-[#221C51]">{title || journey.title}</h2>
        <p className="text-sm text-gray-400 mt-0.5">Étape {step + 1} sur {steps.length}</p>
      </div>

      {/* Progression */}
      <div className="h-1.5 bg-gray-100 rounded-full mb-6 overflow-hidden">
        <div className="h-1.5 bg-[#221C51] transition-all duration-500" style={{ width: `${((step + 1) / steps.length) * 100}%` }} />
      </div>

      {/* Étape courante */}
      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-8 text-center">
        <div className="text-5xl mb-3">{cur?.emoji}</div>
        <h3 className="text-xl font-bold text-[#221C51] mb-2">{cur?.title}</h3>
        <p className="text-sm text-gray-500 max-w-md mx-auto mb-6">{cur?.subtitle}</p>
        {cur?.cta && (
          <button onClick={go} className="px-6 py-2.5 bg-green-600 text-white font-semibold text-sm rounded-xl hover:bg-green-700 shadow-md">
            {cur.cta.label} →
          </button>
        )}
      </div>

      {/* Navigation */}
      <div className="flex items-center justify-between mt-5">
        <button onClick={() => setStep((s) => Math.max(0, s - 1))}
          className={`text-sm font-medium px-5 py-2.5 rounded-xl ${step === 0 ? "invisible" : "text-gray-400 hover:text-gray-600 hover:bg-gray-100"}`}>← Retour</button>
        <div className="flex gap-1.5">
          {steps.map((_, i) => (
            <button key={i} onClick={() => setStep(i)} aria-label={`Étape ${i + 1}`}
              className={`rounded-full transition-all ${i === step ? "w-6 h-2 bg-[#221C51]" : i < step ? "w-2 h-2 bg-[#221C51]/40" : "w-2 h-2 bg-gray-200"}`} />
          ))}
        </div>
        <button onClick={() => (last ? go() : setStep((s) => s + 1))}
          className="px-6 py-2.5 bg-[#221C51] text-white font-semibold text-sm rounded-xl hover:bg-[#2d2570] shadow-md">
          {last ? "Terminer" : "Suivant →"}
        </button>
      </div>
    </div>
  );
};

export default JourneyFlow;
